import { useMemo } from 'react'
import { featureFlags } from 'featureFlags'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { env } from 'utils'

type KebabToCamelCase<S extends string> = S extends `${infer T}-${infer U}`
    ? `${T}${Capitalize<KebabToCamelCase<U>>}`
    : S

export type FeatureFlags = {
    [K in keyof typeof featureFlags as KebabToCamelCase<K>]: (typeof featureFlags)[K]
}

/**
 * Returns the feature flags, with overrides from the environment variable VITE_FEATURE_FLAG_OVERRIDES
 * To override, add:
 * VITE_FEATURE_FLAG_OVERRIDES='{"enableSharedSyncer": true}'
 * to .env.local
 */
export const useFeatureFlags = () => {
    const flags = useFlags() as unknown as FeatureFlags
    return useMemo(() => {
        if (env.DEV && env.VITE_FEATURE_FLAG_OVERRIDES) {
            const overrides = JSON.parse(env.VITE_FEATURE_FLAG_OVERRIDES) as unknown as FeatureFlags
            return {
                ...flags,
                ...overrides,
            }
        }
        return flags
    }, [flags])
}

export const useEnabledLDFlagsAsJson = () => {
    const flags = useFeatureFlags()
    return useMemo(() => {
        try {
            return JSON.stringify(
                Object.keys(flags).filter((flag) => flags[flag as keyof typeof flags]),
            )
        } catch (error) {
            return
        }
    }, [flags])
}
